import React, {useEffect, useState} from 'react';
import { Button, Form, Modal, notification, Upload } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import {uploadDocumentIndex, uploadDocumentTrade} from '../actions';
import { IModalCreate } from '../stats-external-admin.types';
import {getExt, localize} from "mixins/helpers";

const AddItemModal = (props: IModalCreate) => {
    const [fileList, setFileList] = useState<any[]>([]);
    const [uploading, setUploading] = useState(false);
    const [form] = Form.useForm();
    const [filesSize, setFilesSize] = useState(0);

    const fileProps: UploadProps = {
        beforeUpload: (file) => {
            if (['zip','rar','jar','tar'].includes(getExt(file.name))) {
                const isLt15M = file.size / 1024 / 1024 < 20;
                if (isLt15M) {
                    setFileList((items) => [...items, file]);
                } else {
                    notification['warning']({
                        message: localize('stats-external-maximum-mb', props.translations),
                    });
                }
            } else {
                notification['warning']({
                    message: localize('stats-external-format-not', props.translations),
                    description: localize('stats-external-file-zip', props.translations),
                });
            }

            return false;
        },
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        fileList,
    };

    useEffect(() => {
        let sizeSum = 0;
        fileList.forEach(x => {
            sizeSum = sizeSum + x.size
        });
        setFilesSize(sizeSum);
    }, [fileList]);

    const clearData = () => {
        form.resetFields();
        setFileList([]);
    };

    const handleOk = () => {
        form.validateFields().then(() => {
            if (fileList.length > 0) {

                if (filesSize / 1024 / 1024 < 20) {
                    setUploading(true);

                    const bodyFormData = new FormData();

                    fileList.forEach((file) => {
                        bodyFormData.append('files', file);
                    });

                    const request = props.category === 'INDEX'
                        ? uploadDocumentIndex(bodyFormData)
                        : uploadDocumentTrade(bodyFormData);

                    request.then(() => {
                        notification['success']({
                            message: localize('stats-external-file-successfully', props.translations),
                        });
                        props.handleOk();
                        clearData();
                    })
                        .finally(() => setUploading(false));
                } else {
                    notification['warning']({
                        message: localize('stats-external-maximum-mb', props.translations),
                    });
                }
            } else {
                notification['warning']({
                    message: localize('stats-external-file-no', props.translations),
                });
            }
        });
    };

    const handleCancel = () => {
        props.handleCancel();
        clearData();
    };

    return (
        <Modal
            title={localize('stats-external-file-add', props.translations)}
            open={props.isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button
                    className="admin"
                    type="default"
                    onClick={handleCancel}
                >
                    {localize('cancel', props.translations)}
                </Button>,
                <Button
                    className="admin"
                    type="primary"
                    onClick={handleOk}
                    loading={uploading}
                >
                    Добавить
                </Button>,
            ]}
        >
            <div className="my-3">
                <Form
                    layout="vertical"
                    form={form}
                >
                    <Upload
                        {...fileProps}
                        accept=".zip,.rar,.jar,.tar"
                        multiple
                    >
                        <Button>{localize('button.upload-file', props.translations)}</Button>
                    </Upload>
                </Form>
            </div>
        </Modal>
    );
};

export default AddItemModal;
